import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Image, message, Popconfirm, Table } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { basicSort, TableColumnTextFilterConfig } from '../../common/TableHelper';
import { useDeleteUmkmCategoryMutation, useGetAllUmkmCategoriesQuery } from './umkmCategoryAPI';
import { UmkmCategory } from './types';

function UmkmCategoryList() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetAllUmkmCategoriesQuery();
  const [deleteCategory] = useDeleteUmkmCategoryMutation();

  const handleDelete = async (id: number) => {
    try {
      await deleteCategory(id).unwrap();
      message.success('Kategori berhasil dihapus');
    } catch (error) {
      message.error('Gagal menghapus kategori');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a: UmkmCategory, b: UmkmCategory) => basicSort(a.id, b.id),
      width: 80,
    },
    {
      title: 'Gambar',
      dataIndex: 'image',
      key: 'image',
      width: 100,
      render: (image: string) => (image ? <Image src={image} width={60} height={60} style={{ objectFit: 'cover' }} /> : '-'),
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: UmkmCategory, b: UmkmCategory) => basicSort(a.name, b.name),
      ...TableColumnTextFilterConfig<UmkmCategory>('name'),
    },
    {
      title: 'Deskripsi',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: 'Aksi',
      key: 'action',
      width: 120,
      render: (record: UmkmCategory) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button type="primary" icon={<EditOutlined />} onClick={() => navigate(`edit/${record.id}`)} size="small" />
          <Popconfirm title="Yakin ingin menghapus kategori ini?" onConfirm={() => handleDelete(record.id)} okText="Ya" cancelText="Tidak">
            <Button danger icon={<DeleteOutlined />} size="small" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <ContentWithErrorHandler isError={error} isLoading={isLoading}>
      <Card
        title="Kategori UMKM"
        size="small"
        extra={
          <Button style={{ borderRadius: 5 }}>
            <Link to="create">+ Tambah Kategori</Link>
          </Button>
        }
      >
        <Table columns={columns} dataSource={data} rowKey="id" />
      </Card>
    </ContentWithErrorHandler>
  );
}

export default UmkmCategoryList;
